import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { RequestSubmissionInfo } from "../../../../../api/types/dataCollectionTypes";

interface Props {
  hasPermissionsToManage: boolean;
  onPublishSubmissions: (submissions: RequestSubmissionInfo[]) => void;
  onUnpublishSubmissions: (submissions: RequestSubmissionInfo[]) => void;
  onSendSubmissionReminders: (submissions: RequestSubmissionInfo[]) => void;
  onRequestChangesForSubmissions: (submissions: RequestSubmissionInfo[]) => void;
  onDeleteSubmissions: (submissions: RequestSubmissionInfo[]) => void;
  onChangeSubmissionsDueDate: (submissions: RequestSubmissionInfo[]) => void;
}

const DataRequestPageContext = createContext<Props | undefined>(undefined);

export const DataRequestPageContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <DataRequestPageContext value={contextValue}>{children}</DataRequestPageContext>
);

export default DataRequestPageContext;
